export class EngineeringNotation {

  // Calculate the exponent for converting to engineering notation.
  private static exponent(value: number): number {
    return value === 0 ? 0 : Math.floor(Math.log10(Math.abs(value)) / 3);
  }

  // Get the SI prefix based on the exponent.
  private static prefix(exponent: number): string {
    const prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
    return prefixes[exponent + 8];
  }

  // Convert a number to engineering notation as a string.
  public static toString(value: number, symbol: string = '', precision: number = 2): string {
    const exp = EngineeringNotation.exponent(value);
    const scaledValue = value * Math.pow(1000, -exp);
    const prefix = EngineeringNotation.prefix(exp);

    // Format the number and remove trailing zeros
    let formattedNumber = scaledValue.toFixed(precision);
    formattedNumber = formattedNumber.replace(/(\.\d*?)0+$/, "$1"); // Remove trailing zeros
    formattedNumber = formattedNumber.replace(/\.$/, ""); // Remove the decimal point if it's the last character

    return `${formattedNumber} ${prefix}${symbol}`;

  }
}
